export const TOUR_OPERATOR_PUBLISH_REVIEW_START = "TOUR_OPERATOR_PUBLISH_REVIEW_START";
export const TOUR_OPERATOR_PUBLISH_REVIEW_SUCCESS = "TOUR_OPERATOR_PUBLISH_REVIEW_SUCCESS";
export const TOUR_OPERATOR_PUBLISH_REVIEW_ERROR = "TOUR_OPERATOR_PUBLISH_REVIEW_ERROR";

export const TOUR_OPERATOR_DECLINED_REVIEW_START = "TOUR_OPERATOR_DECLINED_REVIEW_START";
export const TOUR_OPERATOR_DECLINED_REVIEW_SUCCESS = "TOUR_OPERATOR_DECLINED_REVIEW_SUCCESS";
export const TOUR_OPERATOR_DECLINED_REVIEW_ERROR = "TOUR_OPERATOR_DECLINED_REVIEW_ERROR";

export const TOUR_OPERATOR_NEW_REVIEW_START = "TOUR_OPERATOR_NEW_REVIEW_START";
export const TOUR_OPERATOR_NEW_REVIEW_SUCCESS = "TOUR_OPERATOR_NEW_REVIEW_SUCCESS";
export const TOUR_OPERATOR_NEW_REVIEW_ERROR = "TOUR_OPERATOR_NEW_REVIEW_ERROR";